import { render, staticRenderFns } from "./DetectionBarChart.vue?vue&type=template&id=0909bce2"
import script from "./DetectionBarChart.vue?vue&type=script&lang=js"
export * from "./DetectionBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports